<template>
    <div class="wrapper">
        <el-header>
            <v-header></v-header>
        </el-header>
        <el-container>
            <el-aside>
                <v-sidebar></v-sidebar>
            </el-aside>
            <el-container>
                <el-main :class="collapseObject">
                    <v-tags></v-tags>
                    <div class="content">
                        <transition name="move" mode="out-in">
                            <keep-alive :include="tagsList">
                                <router-view></router-view>
                            </keep-alive>
                        </transition>
                        <el-backtop target=".content"></el-backtop>
                    </div>
                </el-main>
            </el-container>
        </el-container>

        <!--<charts ref="charts" @flash="flash" v-if="showChart"></charts>-->
    </div>
</template>

<script>
    import vSidebar from "./components/SideBar";
    import vHeader from "./components/Header";
    import vTags from "./components/Tags"
    import {mapState,mapMutations} from 'vuex';
    import bus from '@/assets/js/bus';

    export default {
        name: "Home",
        data() {
            return {
                tagsList: [],
                showChart: true,
            }
        },
        components: {
            vSidebar,
            vHeader,
            vTags
        },
        computed: {
            ...mapState(['isCollapse','user_info']),
            collapseObject() {
                return {
                    'main-collapse': this.isCollapse,
                    'main-notCollapse': !this.isCollapse
                }
            }
        },
        created() {
            // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
            bus.$on('tags', msg => {
                let arr = [];
                for (let i = 0, len = msg.length; i < len; i++) {
                    msg[i].name && arr.push(msg[i].name);
                }
                this.tagsList = arr;
            });
        },
        methods:{
            ...mapMutations(['setUserInfo']),
            getUserInfo(){
                this.http.fetchGet(this.api.user_info).then((res)=>{
                        var data=res.data;
                        localStorage.setItem('user_type',data.role_id);
                        this.setUserInfo(data);
                    }
                ).catch(err => {
                    console.log(err)
                })
            }
        },
        mounted() {
            //获取用户信息
            // console.log(localStorage.getItem('access_token'));
            // console.log(this.$store.state.access_token);
            // console.log(this.user_info);
            // console.log(JSON.parse(localStorage.getItem('user_info')))
            this.getUserInfo();
            
            // 页面加载时立即刷新权限和菜单（解决用户刷新页面获取最新权限的需求）
            this.$store.dispatch('refreshUserPermissions').then(() => {
                console.log('页面加载：权限已刷新');
            }).catch(err => {
                console.error('页面加载：权限刷新失败', err);
            });
            
            // 上次刷新时间
            this.lastRefreshTime = Date.now();
            
            // 定时刷新用户权限和菜单（每10分钟）
            this.permissionRefreshTimer = setInterval(() => {
                this.$store.dispatch('refreshUserPermissions').then(() => {
                    console.log('后台已更新用户权限');
                    this.lastRefreshTime = Date.now();
                }).catch(err => {
                    console.error('后台权限更新失败:', err);
                });
            }, 10 * 60 * 1000); // 10分钟
            
            // 监听路由变化，切换页面时刷新权限（防抖：30秒内只刷新一次）
            this.unwatchRoute = this.$watch('$route', () => {
                const now = Date.now();
                if (now - this.lastRefreshTime > 30 * 1000) {
                    this.$store.dispatch('refreshUserPermissions').then(() => {
                        this.lastRefreshTime = now;
                    }).catch(err => {
                        console.error('路由变化权限更新失败:', err);
                    });
                }
            });
            
            // 监听页面可见性变化，用户返回标签页时刷新（防抖：30秒）
            this.handleVisibilityChange = () => {
                if (!document.hidden) {
                    const now = Date.now();
                    if (now - this.lastRefreshTime > 30 * 1000) {
                        this.$store.dispatch('refreshUserPermissions').then(() => {
                            this.lastRefreshTime = now;
                        }).catch(err => {
                            console.error('页面聚焦权限更新失败:', err);
                        });
                    }
                }
            };
            document.addEventListener('visibilitychange', this.handleVisibilityChange);
        },
        beforeDestroy() {
            // 清除定时器
            if (this.permissionRefreshTimer) {
                clearInterval(this.permissionRefreshTimer);
            }
            // 清除路由监听
            if (this.unwatchRoute) {
                this.unwatchRoute();
            }
            // 清除页面可见性监听
            if (this.handleVisibilityChange) {
                document.removeEventListener('visibilitychange', this.handleVisibilityChange);
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/assets/css/varibles.styl"
    .el-header
        line-height $hdHeight
        height $hdHeight !important
        position absolute
        left 0
        right 0
        top 0
        /*padding-bottom: 30px;*/
        -webkit-transition: left .3s ease-in-out
        transition: left .3s ease-in-out
        background: #585855
        color #fff
        padding 0

    .el-main
        padding 0
        -webkit-transition left .3s ease-in-out
        transition left .3s ease-in-out
        background $bgColor

    .main-notCollapse
        position absolute
        left $menuWidth
        right 0
        top $hdHeight
        bottom 0

    .main-collapse
        position absolute
        left $SbCWidth
        right 0
        top $hdHeight
        bottom 0

    /*.wrapper
        overflow hidden*/
</style>
